// @flow

import type {ApplicationState} from '../../types'
import type {MapState} from '../types'
import {getCityMap} from './getCityMap'

export function getCityByUrl(appState: ApplicationState, cityUrl: ?Url): ?City {
  return _getCityByUrl(appState.map, cityUrl) 
}

function _getCityByUrl(state: MapState, cityUrl: ?Url): ?City{
  if (!cityUrl) return null
  const cities: Map<City> = getCityMap.internal(state) 
  return cities[cityUrl]
}

getCityByUrl.internal = _getCityByUrl
